export default __webpack_public_path__ + "static/media/1950.91f848cc.png";